import { render } from "./pop-up.vue?vue&type=template&id=1bf90578&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1bf90578"

export default script